import { CheckIcon } from "@heroicons/react/24/outline"
import React from "react"

export default function GridWithText({ listitems }) {
	return (
		<>
			<dl className="space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-4 lg:grid-cols-2 lg:gap-x-6">
				{listitems.map((feature) => (
					<div
						key={feature.title}
						className="relative"
					>
						<dt>
							<CheckIcon
								className="absolute h-6 w-6 text-green-500"
								aria-hidden="true"
							/>
							<dd
								className="mt-2 ml-9 text-base text-gray-500"
								dangerouslySetInnerHTML={{
									__html: feature.shortDescription.childMarkdownRemark.html,
								}}
							></dd>
						</dt>
					</div>
				))}
			</dl>
			{/* <div className="grid md:grid-cols-2 gap-6">
        {listitems.map((feature) => {
          return (
            <div className="inline-flex">
              <Icon
                iconName="Check"
                className="flex-shrink-0 h-6 w-6 mr-2 text-primary-600"
                aria-hidden="true"
              />
              <div
                key={feature.title}
                className="font-normal text-lg text-gray-900"
                dangerouslySetInnerHTML={{
                  __html: feature.shortDescription.childMarkdownRemark.html,
                }}
              >
              </div>
            </div>
          );
        })}
      </div> */}
		</>
	)
}
